export function setStickyElement() {

    $(".sticky-element").each(function () {
        let ofTop = $(this).attr("offset-top");
        let winWidth = $(window).width();

        if ($(this).hasClass("anchor-nav")) {
            if (winWidth >= 768 && winWidth < 1200) {
                $(this).stick_in_parent({
                    offset_top: 70,
                });
            } else if (winWidth >= 1200 && winWidth < 1600) {
                $(this).stick_in_parent({
                    offset_top: 98,
                });
            } else if (winWidth >= 1600 && winWidth < 1800) {
                $(this).stick_in_parent({
                    offset_top: 111,
                });
            } else if (winWidth >= 1800) {
                $(this).stick_in_parent({
                    offset_top: 116,
                });
            }
        } else {
            $(this).stick_in_parent({
                offset_top: ofTop || 0,
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyElement.js